import { c as _c } from "react/compiler-runtime";
import { Button, Text } from '@chakra-ui/react';
import { advisorsBreadcrumbsWithTrail, useAdvisorsToolbar } from '@src/components/sco/Advisors/hooks/useAdvisorsToolbar';
import { useCreateAdvisorAgreement } from '@src/components/sco/Advisors/hooks/useCreateAdvisorAgreement';
import { AdvisorsSubNavLayout } from '@src/components/sco/Advisors/layout/AdvisorsSubNavLayout';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import type { AgreementStatusFilter } from '@src/components/sco/Advisors/utils/agreementList';
import { agreementsNavItems } from '@src/components/sco/Advisors/utils/agreementsNav';
import { ReactNode } from 'react';
import { LuFileText } from 'react-icons/lu';

/**
 * FAST Agreements shell — status sub-nav rail plus section content.
 *
 * Create a New Agreement is the rail CTA so it stays reachable from every view.
 */
export const AgreementsLayout = t0 => {
  const $ = _c(21);
  const {
    activeKey,
    title,
    description,
    counts,
    children
  } = t0;
  const paths = useAdvisorsPaths();
  const createAgreement = useCreateAdvisorAgreement();
  const navItems = agreementsNavItems(paths);
  let t1;
  if ($[0] !== activeKey) {
    t1 = item => item.key === activeKey;
    $[0] = activeKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const activeItem = navItems.find(t1);
  useAdvisorsToolbar({
    breadcrumbs: activeKey === "all" ? advisorsBreadcrumbsWithTrail({
      title: "FAST Agreements",
      href: paths.agreements
    }) : advisorsBreadcrumbsWithTrail({
      title: "FAST Agreements",
      href: paths.agreements
    }, {
      title: activeItem?.title ?? "Agreements",
      href: activeItem?.href ?? paths.agreements
    })
  });
  const T0 = AdvisorsSubNavLayout;
  const t2 = "FAST equity terms you have drafted, sent, or been asked to sign.";
  const t3 = "FAST Agreements";
  let t4;
  if ($[2] !== counts) {
    t4 = item_0 => ({
      key: item_0.key,
      title: item_0.title,
      href: item_0.href,
      icon: item_0.icon,
      count: counts?.[item_0.key]
    });
    $[2] = counts;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = navItems.map(t4);
  let t6;
  if ($[4] !== createAgreement) {
    t6 = () => void createAgreement.create();
    $[4] = createAgreement;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <LuFileText />;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== createAgreement.loading || $[8] !== t6) {
    t8 = <Button loading={createAgreement.loading} size="sm" variant="cta" width="full" onClick={t6}>{t7} Create a New Agreement</Button>;
    $[7] = createAgreement.loading;
    $[8] = t6;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== createAgreement.error) {
    t9 = createAgreement.error ? <Text color="red.fg" fontSize="sm">{createAgreement.error}</Text> : null;
    $[10] = createAgreement.error;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== T0 || $[13] !== activeKey || $[14] !== children || $[15] !== description || $[16] !== t5 || $[17] !== t8 || $[18] !== t9 || $[19] !== title) {
    t10 = <T0 activeKey={activeKey} description={description} railDescription={t2} railTitle={t3} title={title} items={t5} railFooter={t8}>{t9}{children}</T0>;
    $[12] = T0;
    $[13] = activeKey;
    $[14] = children;
    $[15] = description;
    $[16] = t5;
    $[17] = t8;
    $[18] = t9;
    $[19] = title;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};